var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimetrackingpause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2525_9752)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02148 18.2241H12.0071V7.77441H9.02148V18.2241ZM14.9927 7.77441V18.2241H17.9784V7.77441H14.9927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2525_9752"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetrackingpause);
export default __webpack_public_path__ + "static/media/time trackingpause.61fd66e6394bda941f9ea009b18558a7.svg";
export { ForwardRef as ReactComponent };